import loan from './loan';
import globalLoading from './globalLoading';
import user from './user';
import account from './account';
import person from './person';
let action = { loan, globalLoading, user, account, person };

export default action;
